"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Inject = void 0;
var helpers_1 = require("./helpers");
function Inject(name, scope) {
  var value;
  return function (target, propName) {
    Reflect.defineProperty(target, propName, {
      get: function get() {
        if (!value) {
          value = helpers_1.inject(name, scope);
        }
        return value;
      }
    });
  };
}
exports.Inject = Inject;